<template>
  <router-view v-slot="{ Component }" :key="route.fullPath">
    <transition :name="transitionName" mode="out-in">
      <!-- <keep-alive :include="['medicaseList']">
        <component key="$route.name" :is="Component" />
      </keep-alive> -->
      <component key="$route.name" :is="Component" />
      <!-- <component v-if="!$route.meta.keepAlive" key="$route.name" :is="Component" /> -->
    </transition>
  </router-view>
</template>
<script setup>
import { onBeforeMount, onMounted, ref, watch } from 'vue'
import { appPort, getTokenObj } from '@/widget/index'
import { useRoute } from 'vue-router'
import { getGioUserStruct } from '@/api/user'
// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()

const route = useRoute()
const transitionName = ref('')
// 记录浏览的页面路由
const oldPath = ref([route.fullPath])

watch(
  () => route.fullPath,
  (to, from) => {
    // 如果当前路由在已访问路由列表中，表示页面后退
    if (oldPath.value.includes(to)) {
      transitionName.value = 'slide-right'
      // 离开页面时，删除当页面路径
      let index = oldPath.value.indexOf(from)
      oldPath.value.splice(index, 1)
    } else {
      transitionName.value = 'slide-left'
      // 进入新页面记录路径，表示页面前进
      oldPath.value.push(to)
    }
  }
)

onMounted(() => {
  if (appPort()) {
    window.pausePageVideos = () => {
      var doms = document.querySelectorAll('video')
      if (doms.length) {
        for (var i = 0; i < doms.length; i++) {
          doms[i].pause()
        }
      }
    }
    window.webPageRelaod = () => {
      location.reload()
    }
  }
})
onBeforeMount(() => {
  // GIO 埋点
  if (window.gio) {
    // gio('init', '87f7e3c4c896ecf7')
    // gio('send')
    let obj = getTokenObj()
    let userId = Number(obj.userId || 0)
    let token = obj.token
    if (token) {
      window.gio('setUserId', userId)
      getGioUserStruct(userId).then(res => {
        if (res.code == 200) {
          gio('people.set', res.data)
        }
      })
    }
  }
})
</script>
<style lang="scss">
@import '@/assets/scss/index.scss';
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #212224;
  min-height: 100vh;
  width: 750px;
  margin: 0 auto;
  font-size: 20px;
  box-sizing: border-box;
  // overflow: hidden;
}
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 0.3s;
  position: absolute;
  width: 100%;
  left: 0;
}
.slide-right-enter {
  transform: translateX(-100%);
}
.slide-right-leave-active {
  transform: translateX(100%);
}
.slide-left-enter {
  transform: translateX(100%);
}
.slide-left-leave-active {
  transform: translateX(-100%);
}
</style>
